import { c as _c } from "react/compiler-runtime";
import { MemberStatus } from "@components/table/members/members-column/status-column/member-status";
import { ResendInvitation } from "@components/table/members/members-column/status-column/resend-invitation";
/** Content to show for status member column */
export function StatusColumn(t0) {
  const $ = _c(10);
  const {
    companyId,
    project,
    subjectType,
    member
  } = t0;
  let t1;
  if ($[0] !== member) {
    t1 = <MemberStatus member={member} />;
    $[0] = member;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = project?.id;
  let t3;
  if ($[2] !== companyId || $[3] !== member || $[4] !== subjectType || $[5] !== t2) {
    t3 = <ResendInvitation companyId={companyId} projectId={t2} member={member} key={member.email} subjectType={subjectType} />;
    $[2] = companyId;
    $[3] = member;
    $[4] = subjectType;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}